import React from 'react';
import {ThemedView, ThemedText} from '@app/theme';
import Button from '@sharedComponents/Button/Button';
import BottomSheetContainer from '@sharedComponents/Bottomsheet/Bottomsheet';
import LottieView from 'lottie-react-native';
import SystemError from "../../../../../assets/Icons/SystemErrorIcon";

interface KYCSummarySuccessProps {
    isVisible: boolean;
    onClose: () => void;
    errorMessage: string;
    colors: any;
    setShowErrorModal: (showErrorModal: boolean) => void;
}

const KYCSummaryErrorComponent: React.FC<KYCSummarySuccessProps> = ({
                                                                 isVisible,
                                                                 onClose,
                                                                 colors,
                                                                 errorMessage,
                                                                 setShowErrorModal
                                                             }) => {
    return (
        <BottomSheetContainer
            isVisible={isVisible}
            close={onClose}
            onClose={onClose}
            dragComponent={null}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containsTextInput
            containerStyle={{backgroundColor: '#fefefe'}}
            showCloseIcon={true}
        >
            <ThemedView alignItems={"center"} padding={"lg"}>
               <SystemError />
                <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"} textAlign={"center"}>
                    {"Verification failed"}
                </ThemedText>
                <ThemedText variant={"b3r"} textAlign={"center"} mt={"md"} mb={"2xl"}>
                    {errorMessage}
                </ThemedText>
                <Button
                    label="Ok, got it."
                    type="OUTLINED"
                    size='MD'
                    disabled={false}
                    handlePress={() => {
                        setShowErrorModal(false)
                    }}
                    bg={'bg-action-primary'}
                    textColor={colors['text-primary']}
                />
            </ThemedView>
        </BottomSheetContainer>
    );
};

export default KYCSummaryErrorComponent;